import(/* webpackMode: "eager" */ "/vercel/path1/src/app/ea-vs-ed/page.tsx");
